/**
 * Sub-company owner-status client (DEV-3636, Skynet.Accounts behind the accounts
 * gateway). GET /api/sub-companies/me/is-owner returns whether the authenticated
 * caller is an owner of their own sub-company (the server scopes to the caller,
 * so there is no companyId/subCompanyId path param).
 *
 * Drives the compliance gate for the sensitive owner-only homepage zones (the
 * EARNED pillar and the comp-plan chip). A 403/404/error degrades to NOT owner
 * (safe default) so the sensitive zones stay hidden until the endpoint deploys.
 *
 * Response shape (200):
 *   { isOwner: boolean, ownershipPercentage: number|null }
 */
export class SubCompanyOwnerStatusApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getOwnerStatus({ config = {} } = {}) {
    return this.#http.get('/api/command-center/me/is-owner', config);
  }
}
